const ENCompetitors = {
	"Alterar concorrente" : "Change competitor",
	"Ativo é requerido": "Active is required",
	"Concorrentes" : "Competitors",
	"Concorrente adicionado com sucesso": "Competitor successfully added",
	"Concorrente alterado com sucesso" : "Competitor successfully changed",
	"Concorrente excluído com sucesso": "Competitor successfully deleted",
	"Deseja realmente excluir o concorrente" : "Do you really want to delete the competitor",
	"Erro ao excluir concorrente": "Error deleting competitor",
	"Erro ao adicionar concorrente" : "Error adding competitor",
	"Erro ao alterar concorrente" : "Error changing competitor",
	"Exclusão do concorrente" : "Delete competitor",
	"Inserir concorrente": "Insert competitor",
	"Novo concorrente": "New competitor",
	"Criar novo concorrente": "Create new competitor",
	"Erro ao criar novo concorrente": "Error creating new competitor"
};

export default ENCompetitors;

